import { BehaviorSubject } from 'rxjs';

const subject$ = new BehaviorSubject(null);

export function pushToRouter$(value) {
  subject$.next(value);
}

export const router$ = subject$.asObservable();
